// deleteMultipleContacts.ts
import axios from "axios";
import { store } from "../../store/contactAddressStore";
import { selectGroups } from "../../slices/groupSlice";
import { selectAllContacts } from "../../slices/contactAddressSlice";

const API_URL = process.env.REACT_APP_API_URL;

export const deleteMultipleContacts = async (ids: number[]) => {
    const state = store.getState();
    const groups = selectGroups(state);
    const contacts = selectAllContacts(state);

    const invalidContacts = ids
        .map(id => contacts.find(c => c.id === id))
        .filter(contact =>
            groups.some(group => group.members.some(member => member.id === contact?.id))
        );


    if (invalidContacts.length > 0) {
        const names = invalidContacts
            .map(c => c?.contactName || `${c?.lastName || ""} ${c?.firstName || ""}`)
            .join(", ");

        const message =
            "ユーザーがグループに登録されているため、ユーザーを削除できませんでした。\n" +
            `ユーザーのすべてのグループ所属を解除した後、再度、ユーザーを削除してください : ${names}`;

        const error = new Error(message) as any
        error.response = {
            status: 409,
            data: { detail: message }
        }
        throw error
    }

    return await axios.post(
        `${API_URL}/contactAddress/multiple-delete`,
        { ids },
        { withCredentials: true }
    );
};

/**
 * 既存ロジック
 */

// import axios from "axios";

// const API_URL = process.env.REACT_APP_API_URL;

// export const deleteMultipleContacts = async (ids: number[]) => {
//     return await axios.post(`${API_URL}/contactAddress/multiple-delete`, { ids }, { withCredentials: true });
// };
